import request from '@/router/axios';

const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/info/workerList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

const getAllEasyList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/info/workerList2',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

const getSiteAllList = (current, size, params) => request({
  url: '/api/mcc-worker/info/newWorkerList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getInfoList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/info/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

const getWorkerList = (params, deptId) => request({
  url: '/api/mcc-worker/info/workerLists',
  method: 'get',
  params: {
    ...params,
    deptId,
  },
})

const addList = params => request({
  url: '/api/mcc-worker/info/addWorker',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-worker/info/remove',
  method: 'post',
  params: {
    ids,
  },
})

const getWorkBaseDetail = params => request({
  url: '/api/mcc-worker/info/workerDetail',
  method: 'get',
  params: {
    ...params,
  },
})

const getDetail = () => request({
  url: '/api/mcc-worker/employment/detail',
  method: 'get',
})
const updateBaseInfo = (params, headers) => request({
  url: '/api/mcc-worker/info/update1',
  method: 'post',
  headers,
  data: params,
})
// 设为工长
const setSupervis = params => request({
  url: '/api/mcc-worker/team/addTeam',
  method: 'post',
  data: params,
})
// 取消工长
const cancelSupervis = params => request({
  url: '/api/mcc-worker/team/delTeam',
  method: 'post',
  params,
})

const updateEployment = (params, headers) => request({
  url: '/api/mcc-worker/employment/update1',
  method: 'post',
  headers,
  data: params,
})

const getSpeciaList = () => request({
  // url: '/api/mcc-worker/specialist/list',
  url: '/api/mcc-worker/companyspecialist/page',
  method: 'get',
  params: {
    current: 1,
    size: -1,
  },
})

const getTeamList = params => request({
  url: '/api/mcc-worker/project/listTeam',
  method: 'get',
  params,
})

// 上传excel
const uploadWorker = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/mcc-worker/info/addWorker2',
    method: 'post',
    data: formData,
  })
}

// 下载excel
const downLoadExcel = params => request({
  url: '/api/mcc-worker/info/workerExcel',
  method: 'get',
  responseType: 'blob',
  params: {
    size: -1,
    ...params,
  },
})

// 查询所有列表
export const getAllWorkerList = (current, size, params) => request({
  url: '/api/mcc-worker/info/getExcel',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

// 文件批量上传
export const uploadWorkerFile = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/blade-resource/oss/endpoint/put-file-attach2',
    method: 'post',
    data: formData,
  })
}

const getStaffInfo = params => request({
  url: '/api/mcc-staff/staff/staffList',
  method: 'get',
  params: {
    ...params,
  },
})

const updateWorkerTeam = params => request({
  url: '/api/mcc-worker/info/updateWorkerTeam',
  method: 'post',
  params: { ...params },
})

const getPosition = params => request({
  url: '/api/mcc-worker/position/list',
  method: 'get',
  params: {
    ...params,
  },
})

export default {
  getList,
  getAllEasyList,
  getSiteAllList,
  remove,
  getWorkerList,
  getDetail,
  getWorkBaseDetail,
  addList,
  updateBaseInfo,
  updateEployment,
  getSpeciaList,
  setSupervis,
  cancelSupervis,
  getInfoList,
  getTeamList,
  uploadWorker,
  downLoadExcel,
  getStaffInfo,
  updateWorkerTeam,
  getPosition,
}
